import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Select from 'components/generics/Select';

const ExploitationTableRow = ({ data, handleData, deleteData, checked, setChecked }) => {
  const { t } = useTranslation();
  const [selectedSecteur, setSelectedSecteur] = useState('');
  const [selectedExploitation, setSelectedExploitation] = useState('');

  const isChecked =
    checked?.find(
      (checkedExploitation) =>
        checkedExploitation?.exploitationId === data?.exploitation?.wiuzExploitationId,
    )?.checked || false;
  useEffect(() => {
    if (data.exploitation.sectorId) {
      setSelectedSecteur(data.exploitation.sectorId);
    }
    if (data.exploitation.exploitationTypeName) {
      let found = data.type.filter(
        (d) => d.exploitationTypeName === data.exploitation.exploitationTypeName,
      );
      if (found.length > 0) {
        setSelectedExploitation(found[0].id);
      } else {
        setSelectedExploitation(data.type.filter((d) => d.isDefaultType === true)[0]?.id);
      }
    } else {
      setSelectedExploitation(data.type.filter((d) => d.isDefaultType === true)[0]?.id);
    }
  }, [data]);

  const handleChange = (e, from) => {
    let dataToHandle;
    switch (from) {
      case 'secteur':
        setSelectedSecteur(e);
        dataToHandle = {
          exploitationId: +data.exploitation.wiuzExploitationId,
          sectorId: +e,
          exploitationTypeId: +selectedExploitation,
        };
        handleData(dataToHandle);
        break;
      case 'exploitation':
        setSelectedExploitation(e);
        dataToHandle = {
          exploitationId: +data.exploitation.wiuzExploitationId,
          sectorId: +selectedSecteur,
          exploitationTypeId: +e,
        };
        handleData(dataToHandle);
        break;
      case 'checkbox':
        setChecked((prevChecked) =>
          prevChecked.map((prevCheckedExploitation) =>
            prevCheckedExploitation?.exploitationId === data?.exploitation?.wiuzExploitationId
              ? { ...prevCheckedExploitation, checked: !isChecked }
              : {
                  ...prevCheckedExploitation,
                  checked: false,
                },
          ),
        );
        if (isChecked) {
          deleteData(data.exploitation.wiuzExploitationId);
        } else {
          dataToHandle = {
            exploitationId: +data.exploitation.wiuzExploitationId,
            sectorId: +selectedSecteur,
            exploitationTypeId: +selectedExploitation,
          };
          handleData(dataToHandle);
        }
        break;
      default:
        break;
    }
  };

  return (
    <tr>
      <td className="import">
        <input
          type={'checkbox'}
          checked={isChecked}
          onChange={(e) => handleChange(e, 'checkbox')}
        />
      </td>
      <td>{data.exploitation.wiuzExploitationName}</td>
      <td>
        <Select
          className="reduce"
          name="secteur"
          options={[{ id: 0, name: t('label.assoliaSectors') }, ...data.secteur]}
          value={selectedSecteur}
          itemLabel="name"
          itemValue="id"
          disabled={!isChecked || !!data.exploitation.sectorId}
          onChange={(e) => handleChange(e, 'secteur')}
        />
      </td>
      <td>
        <Select
          className="reduce"
          name="exploitation"
          options={[{ id: 0, exploitationTypeName: t('label.exploitationTypes') }, ...data.type]}
          value={selectedExploitation}
          itemLabel="exploitationTypeName"
          itemValue="id"
          disabled={!isChecked || !!data.exploitation.exploitationTypeName}
          onChange={(e) => handleChange(e, 'exploitation')}
        />
      </td>
    </tr>
  );
};

export default ExploitationTableRow;
